@if (showAllDocuments === true) {
  <div class="content-style-class document-container">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column">
        <h2 class="title-style">{{ documentTitle }}</h2>
      </div>
      <div
        *appCheckPermission="{ context: 'Documents', action: Action.CREATE }"
      >
        <div fxLayout="column" class="add-button-style">
          <abc-speed-dial-action icon="add" (onClick)="addDocument()">
          </abc-speed-dial-action>
        </div>
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings card-radius">
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="10px"
          style="margin-bottom: 20px"
        >
          <abc-button
            [visible]="isReset"
            icon="refresh"
            (onClick)="resetData()"
          >
          </abc-button>
          <abc-select-box
            #filterProjectList
            [displayExpr]="'Designation'"
            [valueExpr]="'Id'"
            fxFlex="200px"
            [label]="filterPanelLabel"
            [labelMode]="'floating'"
            [width]="'100%'"
            [searchEnabled]="true"
            [dataSource]="projectList"
            (onOpened)="prepareProjectList()"
            (onSelectionChanged)="filterDocumentByProject($event)"
          >
          </abc-select-box>
        </div>
        <abc-grid
          #rolesGrid
          class="grid-group-by-Style grid-adaptive-mode"
          [height]="'85%'"
          [maxHeight]="'100%'"
          [dataSource]="documents"
          [noDataText]="noDataText"
          [setupDefaultLayoutOnInitialization]="true"
          [rowAlternationEnabled]="false"
          [columns]="documentsColumnsHeader"
          [showRowLines]="false"
          (onCellPrepared)="onCellPrepared($event)"
          (onCellClick)="onCellClick($event)"
          [columnHidingEnabled]="true"
          [wordWrapEnabled]="true"
          [columnAutoWidth]="false"
        >
          <dxo-export
            [enabled]="false"
            [allowExportSelectedData]="false"
          ></dxo-export>
          <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
          <dxo-editing
            [useIcons]="false"
            [mode]="'row'"
            [allowAdding]="false"
            [allowDeleting]="false"
            [allowUpdating]="false"
          ></dxo-editing>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-filter-panel [visible]="false"></dxo-filter-panel>
          <dxo-search-panel [visible]="false"> </dxo-search-panel>
        </abc-grid>
      </div>
    </div>
  </div>
}

@if (showAllDocuments === false) {
  <div fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column" fxFlex="95"></div>
      <div fxLayout="column" fxLayoutGap="10px">
        <abc-button
          class="buttons-container"
          fxLayoutAlign="end"
          text="{{ dataService.res('Ubt-MeasureDetail-Upload-Document') }}"
          icon="add"
          (onClick)="addDocument()"
        >
        </abc-button>
      </div>
    </div>
    <div fxLayout="row">
      <abc-grid
        #documentsGrid
        class="grid-group-by-Style grid-adaptive-mode"
        [noDataText]="noDataText"
        [dataSource]="documents"
        [columns]="documentsColumnsHeader"
        [showColumnLines]="false"
        [rowAlternationEnabled]="false"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        height="100%"
      >
        <dxo-scrolling [useNative]="true"> </dxo-scrolling>
        <dxo-group-panel [visible]="false"></dxo-group-panel>
        <dxo-selection [mode]="'single'"> </dxo-selection>
        <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-editing
          [useIcons]="false"
          [mode]="'row'"
          [allowAdding]="false"
          [allowDeleting]="false"
          [allowUpdating]="false"
        ></dxo-editing>
        <dxo-paging [enabled]="false"></dxo-paging>
      </abc-grid>
    </div>
  </div>
}

<abc-popup
  #addDocumentPopup
  [showTitle]="true"
  [height]="'auto'"
  [maxHeight]="'50%'"
  [minHeight]="'100px'"
  [width]="'25%'"
  [maxWidth]="'500px'"
  [minWidth]="'250px'"
  [position]="'center'"
  title="{{ dataService.res('Ubt-MeasureDetail-Upload-Document') }}"
  [deferRendering]="'false'"
  [showCloseButton]="true"
>
  <abc-file-uploader
    #fileUploader
    class="dx-card popup-card-paddings card-radius file-uploader-card"
    accept="*"
    [multiple]="true"
    uploadMode="useButtons"
    selectButtonText="{{
      dataService.res('Ubt-MeasureDetail-Select-Document')
    }}"
    [uploadFile]="uploadFile"
    (onUploaded)="closeDocumentPopUp()"
    (onValueChanged)="onFileUpload($event, uploadDocument)"
  >
  </abc-file-uploader>
</abc-popup>

<abc-popup
  #deleteDocumentConfirmationPopup
  [width]="'25%'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [maxHeight]="'30%'"
  [minHeight]="'100px'"
  [maxWidth]="'500px'"
  [minWidth]="'250px'"
  [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res("Ubt-MeasureList-Delete-Message") }}
    </div>
    <dxi-item
      itemType="group"
      fxLayout="row"
      fxLayoutAlign="end end"
      fxLayoutGap="20px"
    >
      <abc-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        (onClick)="removeRow()"
      >
      </abc-button>
      <abc-button
        class="cancel-button"
        [text]="dataService.res('Ubt-Company-Button-Cancel')"
        (onClick)="abortDelete()"
      >
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>
<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
